function getIOSVersion() {
  const ua = navigator.userAgent;
  if (/(iPhone|iPod|iPad)/i.test(ua)) {
    // @ts-ignore
    return ua
      .match(/OS [\d_]+/i)[0]
      .substr(3)
      .split('_')
      .map((n: any) => parseInt(n));
  }
  return [0];
}

export function isAdoptedStyleSheetsSupported() {
  const [major, minor] = getIOSVersion();

  if (major === 0) return true;

  return major >= 16 && minor >= 4;
}
